import { useLCS } from '@works-web/settings/modules/nds';
import { MenuItemId, PageContent } from '@works-web/settings/modules/page';
import PropTypes from 'prop-types';
import { AppData } from '~/settings/service/CommonService';
import { AutoReply } from '../autoreply';
import { General } from '../general';
import { Stamp } from '../stamp';
// import { BlockUsers } from '../blockUsers';

MainScene.propTypes = {
  domainJoinYmdt: PropTypes.string.isRequired,
};
export default function MainScene({ domainJoinYmdt }) {
  useLCS('pcset_message');
  // const supportExternalRoom = AppData.DomainConfig.supportExternalRoom;
  const supportStampSuggestion = AppData.supportStampSuggestion;
  // const isGov = window.process.TARGET === 'gov';

  return (
    <PageContent menuItemId={MenuItemId.MESSAGE}>
      <General domainJoinYmdt={domainJoinYmdt} />
      {supportStampSuggestion && <Stamp />}
      <AutoReply />
      {/* {supportExternalRoom && !isGov && <BlockUsers />} */}
    </PageContent>
  );
}
